<!--
  <TableChart
    title="My title"
    :chardata="chardata"
  >
    chardata = {
      name: 'Pi',
      entries: {
        "Serie name": {
          data: [
            3,
            14,
            15,
            93,
          ],
        },
        "Serie name 2": {
          data: [ ... ],
        },
        ...
      },
    }
-->

<template>
  <v-data-table
      :headers="headers"
      :items="values"
      must-sort
      dense
      loading-text="Cargando..."
    >
    </v-data-table>
</template>
  
  
<style lang="scss">
</style>
  
  
<script>
  
  export default {
    name: "TableChart",
  
    props: {
      title: {required: true},
      subtitle: {required: false},
      chardata: {required: true},
    },

    computed: {
      headers() {
        return Object.keys(this.chardata.entries || {}).map(head => ({text: head,value: head}))
      },
      values() {
        let values = []
        for (const [key,value] of Object.entries(this.chardata.entries || {})) {
          for (let [index,val] of value.data.entries()) {
            if (values.length <= index) {
              values.push({[key]: val})
            } else {
              values[index][key] = val
            }
          }
        }
        return values;
      },
    },
  };   
</script>
  